module.exports = __webpack_public_path__ + "static/media/power-by.29bc8e59.png";